<div class="tags">
  <div class="new-dish-label">
    {{ 'MENU.DISHES.NEW.OLD_TAGS' | translate }}
  </div>
  <div class="tags-right">
    <mat-chip-list class="tags-chip-list" aria-label="Tags selection">
      <mat-chip *ngFor="let tag of tags; let i = index" [selectable]="selectable"
                [removable]="removable" (removed)="onRemoveTag(tag)">
        {{tag}}
        <button matChipRemove *ngIf="allowOverrides && removable">
          <mat-icon>cancel</mat-icon>
        </button>
      </mat-chip>
    </mat-chip-list>

    <div class="tags-add-fields" *ngIf="allowOverrides">
      <div class="modifiers-new-name">
        <mat-form-field appearance="fill">
          <mat-label>{{ 'MENU.DISHES.NEW.TAG_NEW_NAME' | translate }}</mat-label>
          <input
            matInput
            type="text"
            [(ngModel)]="currentTagText"
            (focus)="changeEditMode(true)"
            (blur)="changeEditMode(false)"
            (keyup.enter)="onEnter($event)"
          >
          <mat-icon *ngIf="allowOverrides && isTagsDifferent()" matSuffix mat-icon-button aria-label="Clear" matTooltip="{{originalTags}}"
                    (click)="clearTags()">restore
          </mat-icon>
        </mat-form-field>
        <label class="error" *ngIf="error">{{error}}</label>
      </div>
    </div>
  </div>
</div>
